/**
 * Medical Disclaimer — Launch Blocker #12
 *
 * Required on every page showing lab analysis results or supplement protocols.
 * Always present, never a popup or modal. 13px minimum per accessibility requirements.
 */

interface MedicalDisclaimerProps {
  /** Additional Tailwind classes for the outer container */
  className?: string;
}

export function MedicalDisclaimer({ className = '' }: MedicalDisclaimerProps) {
  return (
    <div
      className={`px-4 py-3 border-t border-bg-tertiary ${className}`}
      role="contentinfo"
      aria-label="Medical disclaimer"
    >
      <p className="text-text-muted text-[13px] leading-relaxed text-center">
        <span className="font-semibold text-text-secondary">Not for diagnostic use.</span>{' '}
        HemoLogix provides wellness analysis, not medical diagnosis.
        This report should not be used as a substitute for professional medical evaluation.
        Consult your healthcare provider before starting any supplement regimen.
        HemoLogix does not diagnose, treat, cure, or prevent any disease.
      </p>
    </div>
  );
}
